import emailjs from "@emailjs/browser";
import { MASTER_COLOR_PALETTE } from "../constants";

const COMPANY_NAME    = "Layerstech3d";
const COMPANY_PHONE   = "+91 8849764169";
const COMPANY_ADDRESS = "Hilton Business Centre";
const COMPANY_EMAIL   = "inquiery@layerstech.online";
const COMPANY_GST     = "24ADKPT3486E1ZA";

export const generateInvoiceNumber = () => {
    const now    = new Date();
    const year   = now.getFullYear();
    const month  = now.getMonth() + 1;
    const day    = now.getDate();
    const suffix = String(Math.floor(Math.random() * 900) + 100);
    return `INV-${year}-${month}${day}-${suffix}`;
};

/* ─────────────────────────────────────────────────────────────
   Send order confirmation e-mail via EmailJS
───────────────────────────────────────────────────────────── */
// export const sendOrderEmail = (
//     userDetails,
//     selectedProduct,
//     orderIdToSubmit,
//     deliveryDate,
//     invoiceNumber,
//     shippingCharge = 0,
//     shippingZone   = "Standard Delivery",
//     items          = null
// ) => {
//     const activeColorObject = MASTER_COLOR_PALETTE.find(c => c.id === userDetails.color);
//     const resolvedColorName = activeColorObject ? activeColorObject.name : "Standard Default";
//     const isBuyAll = items && items.length > 0;

//     let productTotal, basePrice, cgst, sgst, gstAmount, grandTotal;
//     let productNameForEmail, quantityForEmail, unitPriceForEmail, productListText;

//     if (isBuyAll) {
//         productTotal = items.reduce((s, i) => s + (i.price || 0), 0);
//         basePrice    = Math.round(productTotal / 1.18);
//         cgst = sgst  = Math.round(basePrice * 9 / 100);
//         gstAmount    = cgst + sgst;
//         grandTotal   = productTotal + shippingCharge; 
//         quantityForEmail    = `${items.length} items`;
//         unitPriceForEmail   = productTotal;
//         productNameForEmail = items.map((it, idx) =>
//             `${idx + 1}. ${it.name}${it.type === "Customize" ? " (Custom 6\")" : ""} — Rs.${it.price}`
//         ).join("\n");
//         productListText = items.map((it, idx) =>
//             `${idx + 1}. ${it.name}${it.type === "Customize" ? " (Custom 6\")" : ""} | Qty: 1 | Price: Rs.${it.price}`
//         ).join("\n");
//     } else {
//         productTotal = Math.round(selectedProduct.sellingPrice * userDetails.quantity * 1.18);
//         basePrice    = Math.round(productTotal / 1.18);
//         cgst = sgst  = Math.round(basePrice * 9 / 100);
//         gstAmount    = cgst + sgst;
//         grandTotal   = productTotal + shippingCharge;
//         quantityForEmail    = userDetails.quantity;
//         unitPriceForEmail   = basePrice;
//         productNameForEmail = `${selectedProduct.name} (${resolvedColorName})`;
//         productListText     = `1. ${selectedProduct.name} (${resolvedColorName}) | Qty: ${userDetails.quantity} | Price: Rs.${productTotal}`;
//     }

//     return emailjs.send("service_vlf632h", "template_wewhayn", {
//         name: userDetails.name, email: userDetails.email,
//         phone: userDetails.phone, address: userDetails.address,
//         order_id: orderIdToSubmit, invoice_number: invoiceNumber || "",
//         product_name: productNameForEmail, product_list: productListText,
//         quantity: quantityForEmail, product_price: unitPriceForEmail,
//         cgst_amount: cgst, sgst_amount: sgst, gst_amount: gstAmount,
//         product_total: productTotal,
//         shipping_charge: shippingCharge === 0 ? "FREE" : `Rs.${shippingCharge}`,
//         shipping_zone: shippingZone, total_price: grandTotal,
//         payment: "Pending (Pay on Delivery)", delivery_date: deliveryDate || "7-9 Business Days",
//         company_name: COMPANY_NAME, company_phone: COMPANY_PHONE,
//         company_email: COMPANY_EMAIL, company_gst: COMPANY_GST
//     }, "rAyQAjN9BdxgX0qL3");
// };

export const sendOrderEmail = (
    userDetails,
    selectedProduct,
    orderIdToSubmit,
    deliveryDate,
    invoiceNumber,
    shippingCharge = 0,
    shippingZone = "Standard Delivery",
    items = null
) => {

    // ✅ Customized product hoy to mail send nai karvano
    if (
        selectedProduct?.type === "Customize" ||
        selectedProduct?.isCustomized ||
        userDetails?.isCustomized
    ) {
        console.log("Customized product detected - Email skipped.");
        return Promise.resolve({ skipped: true });
    }

    const activeColorObject = MASTER_COLOR_PALETTE.find(
        c => c.id === userDetails.color
    );

    const resolvedColorName = activeColorObject
        ? activeColorObject.name
        : "Standard Default";

    const isBuyAll = items && items.length > 0;

    let productTotal,
        basePrice,
        cgst,
        sgst,
        gstAmount,
        grandTotal;

    let productNameForEmail,
        quantityForEmail,
        unitPriceForEmail,
        productListText;

    if (isBuyAll) {

        productTotal = items.reduce((s, i) => s + (i.price || 0), 0);

        basePrice = Math.round(productTotal / 1.18);

        cgst = sgst = Math.round(basePrice * 9 / 100);

        gstAmount = cgst + sgst;

        grandTotal = productTotal + shippingCharge;

        quantityForEmail = `${items.length} items`;

        unitPriceForEmail = productTotal;

        productNameForEmail = items
            .map(
                (it, idx) =>
                    `${idx + 1}. ${it.name} — Rs.${it.price}`
            )
            .join("\n");

        productListText = items
            .map(
                (it, idx) =>
                    `${idx + 1}. ${it.name} | Qty: 1 | Price: Rs.${it.price}`
            )
            .join("\n");

    } else {

        productTotal = Math.round(
            selectedProduct.sellingPrice *
            userDetails.quantity *
            1.18
        );

        basePrice = Math.round(productTotal / 1.18);

        cgst = sgst = Math.round(basePrice * 9 / 100);

        gstAmount = cgst + sgst;

        grandTotal = productTotal + shippingCharge;

        quantityForEmail = userDetails.quantity;

        unitPriceForEmail = basePrice;

        productNameForEmail = `${selectedProduct.name} (${resolvedColorName})`;

        productListText =
            `1. ${selectedProduct.name} (${resolvedColorName}) | Qty: ${userDetails.quantity} | Price: Rs.${productTotal}`;
    }

    return emailjs.send(
        "service_9cobyqr",
        "template_h5w8bo8",
        {
            name: userDetails.name,
            email: userDetails.email,
            phone: userDetails.phone,
            address: userDetails.address,

            order_id: orderIdToSubmit,
            invoice_number: invoiceNumber || "",

            product_name: productNameForEmail,
            product_list: productListText,

            quantity: quantityForEmail,
            product_price: unitPriceForEmail,

            cgst_amount: cgst,
            sgst_amount: sgst,
            gst_amount: gstAmount,

            product_total: productTotal,

            shipping_charge:
                shippingCharge === 0
                    ? "FREE"
                    : `Rs.${shippingCharge}`,

            shipping_zone: shippingZone,

            total_price: grandTotal,

            payment: "Pending (Pay on Delivery)",

            delivery_date:
                deliveryDate || "7-9 Business Days",

            company_name: COMPANY_NAME,
            company_phone: COMPANY_PHONE,
            company_email: COMPANY_EMAIL,
            company_gst: COMPANY_GST
        },
        "xVYfLbxT6ddEuB_re"
    );
};

/* ─────────────────────────────────────────────────────────────
   Customer Product Bill PDF — clean table, no product images
───────────────────────────────────────────────────────────── */
export const generateInvoicePDF = (orderData) => {
    const {
        orderId, invoiceNumber, name, email, phone, address,
        productName, colorName, selectedInch,
        quantity, totalAmount, productTotal, shippingCharge,
        shippingZone, deliveryDate, deliveryTime,
        date, isCustomized, items
    } = orderData;

    const isBuyAll   = items && items.length > 0;
    const invNum     = invoiceNumber || orderId;
    const grandTotal = Number(totalAmount) || 0;
    const prodTotal  = Number(productTotal) || grandTotal;
    const shipping   = Number(shippingCharge) || 0;
    const baseAmount = Math.round(prodTotal / 1.18);
    const cgst       = Math.round(baseAmount * 9 / 100);
    const sgst       = Math.round(baseAmount * 9 / 100);
    const totalGST   = cgst + sgst;
    const zoneLabel  = shippingZone || "Standard Delivery";
    const unitPrice  = !isBuyAll && quantity > 0 ? Math.round(prodTotal / quantity) : prodTotal;

    const productRows = isBuyAll
        ? items.map((item, idx) => `
            <tr style="background:${idx % 2 === 0 ? "#fff" : "#f8fafc"}">
              <td style="text-align:center;font-weight:800;color:#1e3a5f;">${idx + 1}</td>
              <td><span style="font-weight:700;color:#0f172a;">${item.productName}</span>
                  <br/><span style="font-size:11px;color:#64748b;">${item.type}${item.type === "Customize" ? " &bull; 6&quot; Custom" : ""}</span></td>
              <td style="text-align:center;font-weight:600;">1</td>
              <td style="text-align:right;font-weight:600;">&#8377; ${item.price}</td>
              <td style="text-align:right;font-weight:700;color:#15803d;">&#8377; ${item.price}</td>
            </tr>`)
            .join("")
        : `<tr>
              <td style="text-align:center;font-weight:800;color:#1e3a5f;">1</td>
              <td><span style="font-weight:700;color:#0f172a;">${productName}</span>
                  ${colorName ? `<br/><span style="font-size:11px;color:#64748b;">Color: ${colorName}</span>` : ""}
                  ${isCustomized && selectedInch ? `<br/><span style="font-size:11px;color:#64748b;">Size: ${selectedInch}&quot;</span>` : ""}
              </td>
              <td style="text-align:center;font-weight:600;">${quantity}</td>
              <td style="text-align:right;font-weight:600;">&#8377; ${unitPrice}</td>
              <td style="text-align:right;font-weight:700;color:#15803d;">&#8377; ${prodTotal}</td>
           </tr>`;

    const subtotalRow = isBuyAll ? `
        <tr style="background:#f1f5f9;border-top:2px solid #e2e8f0;">
          <td></td><td style="font-weight:700;">Products Subtotal (${items.length} items)</td>
          <td style="text-align:center;font-weight:700;">${items.length}</td><td></td>
          <td style="text-align:right;font-weight:800;font-size:15px;color:#15803d;">&#8377; ${prodTotal}</td>
        </tr>` : "";

    const win = window.open("", "_blank");
    if (!win) { alert("Please allow popups to view the bill."); return; }
    win.document.write(`<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"/>
<title>Customer Bill &mdash; ${invNum}</title><style>
*{margin:0;padding:0;box-sizing:border-box;}
body{font-family:'Segoe UI',Arial,sans-serif;font-size:14px;line-height:1.55;color:#1e293b;background:#f1f5f9;padding:40px 20px;}
.wrap{max-width:820px;margin:0 auto;background:#fff;border-radius:16px;box-shadow:0 8px 40px rgba(0,0,0,.12);overflow:hidden;}
.hdr{background:linear-gradient(135deg,#0f172a,#1e3a5f);color:#fff;padding:38px 50px;display:flex;justify-content:space-between;align-items:flex-start;gap:24px;}
.co-name{font-size:20px;font-weight:800;}.co-meta{margin-top:9px;font-size:12.5px;color:#94a3b8;line-height:1.9;}
.co-gst{display:inline-block;margin-top:12px;background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.22);border-radius:6px;padding:5px 15px;font-size:12px;font-weight:600;}
.inv-right{text-align:right;}.inv-title{font-size:24px;font-weight:800;letter-spacing:2px;text-transform:uppercase;}
.inv-sub{font-size:12px;color:#7dd3fc;margin-top:4px;}.inv-date{font-size:12.5px;color:#94a3b8;margin-top:8px;}
.inv-id{display:inline-block;margin-top:10px;background:rgba(255,255,255,.10);border-radius:6px;padding:5px 15px;font-size:12px;font-weight:600;font-family:'Courier New',monospace;}
.gst-bar{background:#f0fdf4;border-bottom:2px solid #86efac;padding:11px 50px;font-size:12.5px;color:#15803d;font-weight:700;display:flex;align-items:center;flex-wrap:wrap;gap:8px;}
.body{padding:42px 50px;}
.info-row{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin-bottom:34px;}
.info-box h4{font-size:10px;text-transform:uppercase;letter-spacing:1.2px;color:#94a3b8;font-weight:700;margin-bottom:10px;border-bottom:1.5px solid #e2e8f0;padding-bottom:7px;}
.info-box p{font-size:13.5px;color:#334155;margin-bottom:5px;}
.lbl{font-size:11px;font-weight:700;color:#64748b;margin-right:5px;text-transform:uppercase;}
hr{border:none;border-top:1.5px solid #e2e8f0;margin:0 0 28px;}
.cart-badge{display:flex;align-items:center;gap:12px;margin-bottom:22px;padding:14px 20px;background:#eff6ff;border:1.5px solid #bfdbfe;border-radius:12px;}
.cart-pill{background:#1d4ed8;color:#fff;border-radius:8px;padding:6px 14px;font-size:12px;font-weight:700;}
.tbl-wrap{border:1.5px solid #e2e8f0;border-radius:14px;overflow:hidden;margin-bottom:6px;}
table{width:100%;border-collapse:collapse;}
thead tr{background:#1e293b;}thead th{padding:14px 18px;text-align:left;font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.7px;color:#f1f5f9;}
thead th.r{text-align:right;}thead th.c{text-align:center;}
tbody td{padding:15px 18px;font-size:13.5px;color:#334155;border-bottom:1px solid #e2e8f0;vertical-align:middle;}
.tot{width:100%;border-collapse:collapse;}.tot td{padding:12px 18px;font-size:13.5px;border-bottom:1px solid #e2e8f0;}
.tl{color:#64748b;}.tv{text-align:right;font-weight:600;color:#1e293b;}
.gst td{background:#fffbeb;color:#92400e;}.gst .tv{color:#92400e;}
.gst-tot td{background:#fff7ed;color:#c2410c;font-weight:700;}
.ship td{background:#eff6ff;color:#1d4ed8;}.ship .tv{color:#1d4ed8;}
.grand td{background:#0f172a;color:#fff;font-size:15px;font-weight:700;border-bottom:none;}.grand .tv{font-size:17px;}
.gst-notice{display:flex;align-items:flex-start;gap:12px;background:#f0fdf4;border:1.5px solid #86efac;border-radius:12px;padding:18px 22px;margin:20px 0 30px;}
.gst-icon{width:26px;height:26px;border-radius:50%;background:#16a34a;color:#fff;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:800;flex-shrink:0;}
.gst-txt strong{display:block;font-size:13px;color:#14532d;margin-bottom:3px;}.gst-txt span{font-size:12.5px;color:#166534;}
.gst-bk{background:#fff7ed;border:1.5px solid #fed7aa;border-radius:14px;padding:22px 26px;margin-bottom:20px;}
.gst-bk h4{font-size:11px;font-weight:700;color:#c2410c;text-transform:uppercase;letter-spacing:.8px;margin-bottom:18px;}
.gst-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;}
.gc{background:#fff;border:1px solid #fed7aa;border-radius:10px;padding:15px 12px;text-align:center;}
.gc.hi{background:#fff7ed;border-color:#fb923c;}.gl{font-size:10px;font-weight:700;color:#9a3412;text-transform:uppercase;letter-spacing:.6px;}
.gv{font-size:18px;font-weight:700;color:#c2410c;margin-top:7px;}.gst-meta{margin-top:15px;font-size:12px;color:#a16207;font-weight:600;}
.ship-bk{background:#eff6ff;border:1.5px solid #bfdbfe;border-radius:14px;padding:18px 26px;margin-bottom:20px;}
.ship-bk h4{font-size:11px;font-weight:700;color:#1d4ed8;text-transform:uppercase;letter-spacing:.8px;margin-bottom:14px;}
.ship-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;}
.sc{background:#fff;border:1px solid #bfdbfe;border-radius:10px;padding:14px 12px;text-align:center;}
.sl{font-size:10px;font-weight:700;color:#1e40af;text-transform:uppercase;letter-spacing:.6px;}.sv{font-size:17px;font-weight:700;color:#1d4ed8;margin-top:7px;}
.sc.free .sv{color:#15803d;}
.del-box{display:flex;align-items:center;gap:18px;background:#f0fdf4;border:1.5px solid #86efac;border-radius:14px;padding:20px 26px;margin-bottom:30px;}
.del-badge{background:#15803d;color:#fff;font-size:10.5px;font-weight:700;border-radius:7px;padding:8px 14px;flex-shrink:0;letter-spacing:.8px;text-transform:uppercase;}
.dl{font-size:10.5px;font-weight:700;color:#14532d;text-transform:uppercase;letter-spacing:.8px;margin-bottom:5px;}
.dd{font-size:16px;font-weight:700;color:#15803d;}.dt{font-size:12.5px;color:#166534;margin-top:3px;}
.cod{display:flex;align-items:center;justify-content:space-between;background:#fefce8;border:1.5px solid #fde68a;border-radius:12px;padding:16px 26px;margin-bottom:30px;}
.ftr{background:#f8fafc;border-top:1.5px solid #e2e8f0;padding:26px 50px;text-align:center;}
.ftr p{font-size:12.5px;color:#64748b;line-height:1.9;}.ftr strong{color:#334155;}
.btn-row{text-align:center;margin-top:34px;padding-bottom:44px;}
.bp{padding:13px 36px;background:#0f172a;color:#fff;border:none;border-radius:9px;font-size:14px;font-weight:700;cursor:pointer;margin-right:12px;}
.bs{padding:13px 26px;background:#f1f5f9;color:#1e293b;border:1.5px solid #cbd5e1;border-radius:9px;font-size:14px;cursor:pointer;}
@media print{body{background:#fff;padding:0;}.wrap{box-shadow:none;border-radius:0;}.btn-row{display:none;}}
</style></head><body><div class="wrap">
<div class="hdr"><div><div class="co-name">${COMPANY_NAME}</div>
<div class="co-meta">${COMPANY_ADDRESS}<br>Ph: ${COMPANY_PHONE} &nbsp;|&nbsp; ${COMPANY_EMAIL}</div>
<div class="co-gst">GSTIN: ${COMPANY_GST}</div></div>
<div class="inv-right"><div class="inv-title">Customer Bill</div>
<div class="inv-sub">GST-Inclusive Tax Invoice</div>
<div class="inv-date">Date: ${date}</div><div class="inv-id">${invNum}</div></div></div>
<div class="gst-bar">&#9632; All prices include 18% GST &nbsp;|&nbsp; GSTIN: <strong>${COMPANY_GST}</strong> &nbsp;|&nbsp; CGST 9% + SGST 9% &nbsp;|&nbsp; Origin: <strong>394107</strong></div>
<div class="body">
<div class="info-row">
<div class="info-box"><h4>Bill To</h4><p><strong>${name}</strong></p>
<p><span class="lbl">Phone:</span>${phone || "&mdash;"}</p>
${email ? `<p><span class="lbl">Email:</span>${email}</p>` : ""}
<p><span class="lbl">Address:</span>${address || "&mdash;"}</p></div>
<div class="info-box"><h4>Order Details</h4>
<p><span class="lbl">Bill No:</span>${invNum}</p>
<p><span class="lbl">Order ID:</span>${orderId}</p>
<p><span class="lbl">Date:</span>${date}</p>
<p><span class="lbl">Payment:</span>Cash on Delivery</p>
<p><span class="lbl">Type:</span>${isBuyAll ? `Cart Order &mdash; ${items.length} items` : (isCustomized ? "Customized Product" : "Standard Product")}</p>
<p><span class="lbl">Shipping:</span>${zoneLabel}</p></div></div>
<hr/>
${isBuyAll ? `<div class="cart-badge"><div class="cart-pill">&#128722; Cart Order</div>
<div><div style="font-size:14px;font-weight:700;color:#1e3a5f;">${items.length} Products Ordered Together</div>
<div style="font-size:12px;color:#3b82f6;margin-top:2px;">Packed &amp; shipped in one order</div></div></div>` : ""}
<div class="tbl-wrap"><table>
<thead><tr>
<th class="c" style="width:48px;">#</th><th>Product Description</th>
<th class="c" style="width:60px;">Qty</th>
<th class="r" style="width:150px;">Unit Price</th>
<th class="r" style="width:150px;">Total</th>
</tr></thead>
<tbody>
${productRows}${subtotalRow}
<tr style="background:#eff6ff;">
<td style="text-align:center;font-weight:800;color:#1d4ed8;">${isBuyAll ? items.length + 1 : 2}</td>
<td style="color:#1d4ed8;font-weight:600;">Shipping &amp; Delivery &mdash; ${zoneLabel}</td>
<td style="text-align:center;">1</td>
<td style="text-align:right;color:#1d4ed8;">${shipping === 0 ? "FREE" : `&#8377; ${shipping}`}</td>
<td style="text-align:right;font-weight:700;color:${shipping === 0 ? "#15803d" : "#1d4ed8"};">${shipping === 0 ? "FREE" : `&#8377; ${shipping}`}</td>
</tr></tbody></table>
<table class="tot">
<tr><td class="tl">${isBuyAll ? `Products Total (${items.length} items, GST Incl.)` : "Product Total (GST Incl.)"}</td><td class="tv">&#8377; ${prodTotal}</td></tr>
<tr class="gst"><td class="tl">Taxable Base (excl. GST)</td><td class="tv">&#8377; ${baseAmount}</td></tr>
<tr class="gst"><td class="tl">CGST @ 9%</td><td class="tv">&#8377; ${cgst}</td></tr>
<tr class="gst"><td class="tl">SGST @ 9%</td><td class="tv">&#8377; ${sgst}</td></tr>
<tr class="gst-tot"><td class="tl">Total GST 18%</td><td class="tv">&#8377; ${totalGST}</td></tr>
<tr class="ship"><td class="tl">Shipping &mdash; ${zoneLabel}</td><td class="tv">${shipping === 0 ? "FREE" : `&#8377; ${shipping}`}</td></tr>
<tr class="grand"><td class="tl">Grand Total &mdash; Amount Payable on Delivery</td><td class="tv">&#8377; ${grandTotal}</td></tr>
</table></div>
<div class="gst-notice"><div class="gst-icon">&#10003;</div>
<div class="gst-txt"><strong>18% GST included in product price</strong>
<span>CGST 9% (&#8377;${cgst}) + SGST 9% (&#8377;${sgst}) = &#8377;${totalGST} included. Shipping &#8377;${shipping === 0 ? "0 (Free)" : shipping} extra. Total: &#8377;${grandTotal}.</span></div></div>
<div class="gst-bk"><h4>&#9642; GST Breakdown</h4>
<div class="gst-grid">
<div class="gc"><div class="gl">Product Total</div><div class="gv">&#8377; ${prodTotal}</div></div>
<div class="gc"><div class="gl">CGST @ 9%</div><div class="gv">&#8377; ${cgst}</div></div>
<div class="gc"><div class="gl">SGST @ 9%</div><div class="gv">&#8377; ${sgst}</div></div>
<div class="gc hi"><div class="gl">Total GST</div><div class="gv">&#8377; ${totalGST}</div></div>
</div><p class="gst-meta">GSTIN: ${COMPANY_GST} | HSN/SAC: 999912 | Gujarat (24) | PIN 394107</p></div>
<div class="ship-bk"><h4>&#9642; Shipping Details</h4>
<div class="ship-grid">
<div class="sc"><div class="sl">Origin PIN</div><div class="sv">394107</div></div>
<div class="sc"><div class="sl">Zone</div><div class="sv" style="font-size:13px;">${zoneLabel}</div></div>
<div class="sc ${shipping === 0 ? "free" : ""}"><div class="sl">Charge</div><div class="sv">${shipping === 0 ? "FREE" : `&#8377; ${shipping}`}</div></div>
</div></div>
<div class="cod"><span style="font-size:13px;font-weight:600;color:#713f12;">&#9642; Payment: Cash on Delivery (COD)</span>
<span style="font-size:18px;font-weight:700;color:#92400e;">Due on Delivery: &#8377; ${grandTotal}</span></div>
<div class="del-box"><div class="del-badge">Delivery</div>
<div><div class="dl">Estimated Delivery Date</div><div class="dd">${deliveryDate}</div>
<div class="dt">By ${deliveryTime}${isBuyAll && items.some(i => i.type === "Customize") ? " &nbsp;|&nbsp; Includes customized items" : ""}${!isBuyAll && isCustomized ? " &nbsp;|&nbsp; Customized items may take 2 extra days" : ""}</div></div></div>
</div>
<div class="ftr"><p>Thank you for your order. &nbsp;|&nbsp; <strong>${COMPANY_PHONE}</strong> &nbsp;|&nbsp; <strong>${COMPANY_EMAIL}</strong></p>
<p>GSTIN: <strong>${COMPANY_GST}</strong> &nbsp;&bull;&nbsp; ${COMPANY_NAME} &nbsp;&bull;&nbsp; ${COMPANY_ADDRESS}</p>
<p style="font-size:11px;color:#94a3b8;margin-top:9px;">Computer-generated bill. Prices include 18% GST. Shipping added separately.</p></div>
</div>
<div class="btn-row"><button class="bp" onclick="window.print()">&#128438; Save as PDF / Print</button><button class="bs" onclick="window.close()">Close</button></div>
</body></html>`);
    win.document.close(); win.focus();
};

/* ─────────────────────────────────────────────────────────────
   Monthly / Yearly Sales Report PDF — with product breakdown
───────────────────────────────────────────────────────────── */
export const generateSalesReportPDF = (orders, month, year) => {
    const MONTH_NAMES = ["January","February","March","April","May","June",
                         "July","August","September","October","November","December"];
    const periodLabel = month > 0 && year > 0
        ? `${MONTH_NAMES[month - 1]} ${year}`
        : month > 0 ? MONTH_NAMES[month - 1]
        : year > 0  ? String(year)
        : "All Time";

    const totalRevenue  = orders.reduce((s, o) => s + (Number(o.totalAmount) || 0), 0);
    const totalItems    = orders.reduce((s, o) => s + (o.items ? o.items.length : (Number(o.quantity) || 1)), 0);
    const cartOrders    = orders.filter(o => o.isBuyAll).length;
    const singleOrders  = orders.length - cartOrders;
    const avgOrder      = orders.length > 0 ? Math.round(totalRevenue / orders.length) : 0;
    const baseRevenue   = Math.round(totalRevenue / 1.18);
    const totalGST      = totalRevenue - baseRevenue;

    /* ── Product-wise breakdown ── */
    const prodMap = {};
    orders.forEach(o => {
        if (o.isBuyAll && o.items) {
            o.items.forEach(item => {
                const k = item.productName || "Unknown";
                if (!prodMap[k]) prodMap[k] = { name: k, type: item.type || "", qty: 0, amount: 0 };
                prodMap[k].qty += 1;
                prodMap[k].amount += Number(item.price) || 0;
            });
        } else {
            const k   = o.productName || "Unknown";
            const qty = Number(o.quantity) || 1;
            const amt = Number(o.productTotal) || Number(o.totalAmount) || 0;
            if (!prodMap[k]) prodMap[k] = { name: k, type: o.isCustomized ? "Customize" : "Standard", qty: 0, amount: 0 };
            prodMap[k].qty    += qty;
            prodMap[k].amount += amt;
        }
    });
    const prodBreakdown = Object.values(prodMap).sort((a, b) => b.amount - a.amount);

    const prodRows = prodBreakdown.map((p, idx) => `
        <tr style="background:${idx % 2 === 0 ? "#fff" : "#f8fafc"}">
          <td style="text-align:center;font-weight:700;color:#475569;">${idx + 1}</td>
          <td><strong style="color:#0f172a;">${p.name}</strong></td>
          <td style="text-align:center;">
            <span style="background:${p.type === "Customize" ? "#fef3c7" : "#eff6ff"};color:${p.type === "Customize" ? "#92400e" : "#1d4ed8"};border-radius:5px;padding:3px 9px;font-size:11px;font-weight:700;">${p.type || "Standard"}</span>
          </td>
          <td style="text-align:center;font-weight:700;color:#1e293b;">${p.qty}</td>
          <td style="text-align:right;font-weight:700;color:#15803d;">&#8377; ${p.amount.toLocaleString("en-IN")}</td>
        </tr>`).join("");

    const orderRows = orders.map((o, idx) => {
        const itemCount  = o.isBuyAll ? o.items.length : (o.quantity || 1);
        const prodLabel  = o.isBuyAll
            ? o.items.map(i => i.productName).join(", ")
            : (o.productName || "—");
        return `
        <tr style="background:${idx % 2 === 0 ? "#fff" : "#f8fafc"}">
          <td style="text-align:center;font-weight:700;color:#475569;">${idx + 1}</td>
          <td style="font-family:monospace;font-size:12px;color:#1d4ed8;">${o.invoiceNumber || o.orderId || "—"}</td>
          <td><strong>${o.name || "—"}</strong><br/><span style="font-size:11px;color:#64748b;">${o.phone || ""}</span></td>
          <td style="font-size:12px;color:#334155;">${prodLabel.length > 55 ? prodLabel.slice(0, 55) + "…" : prodLabel}</td>
          <td style="text-align:center;">${itemCount}</td>
          <td style="text-align:right;font-weight:700;color:#15803d;">&#8377; ${o.totalAmount || 0}</td>
          <td style="text-align:center;">${o.isBuyAll ? '<span style="background:#eff6ff;color:#1d4ed8;border-radius:5px;padding:3px 8px;font-size:11px;font-weight:700;">Cart</span>' : '<span style="background:#f0fdf4;color:#15803d;border-radius:5px;padding:3px 8px;font-size:11px;font-weight:700;">Single</span>'}</td>
          <td style="text-align:center;font-size:12px;color:#64748b;">${o.date || "—"}</td>
        </tr>`;
    }).join("");

    const win = window.open("", "_blank");
    if (!win) { alert("Please allow popups to view the report."); return; }
    win.document.write(`<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"/>
<title>Sales Report &mdash; ${periodLabel}</title><style>
*{margin:0;padding:0;box-sizing:border-box;}
body{font-family:'Segoe UI',Arial,sans-serif;font-size:13px;color:#1e293b;background:#f1f5f9;padding:36px 20px;}
.wrap{max-width:1100px;margin:0 auto;background:#fff;border-radius:16px;box-shadow:0 8px 40px rgba(0,0,0,.12);overflow:hidden;}
.hdr{background:linear-gradient(135deg,#0f172a,#1e3a5f);color:#fff;padding:36px 50px;display:flex;justify-content:space-between;align-items:flex-start;}
.co-name{font-size:18px;font-weight:800;}.co-meta{margin-top:8px;font-size:12px;color:#94a3b8;line-height:1.8;}
.rpt-title{font-size:22px;font-weight:800;text-transform:uppercase;letter-spacing:2px;text-align:right;}
.period{font-size:15px;color:#7dd3fc;margin-top:6px;font-weight:600;text-align:right;}
.gen{font-size:11px;color:#94a3b8;margin-top:6px;text-align:right;}
.body{padding:38px 50px;}
.kpi-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:16px;margin-bottom:34px;}
.kpi{background:#f8fafc;border:1.5px solid #e2e8f0;border-radius:14px;padding:20px 16px;text-align:center;}
.kpi.g{background:#f0fdf4;border-color:#86efac;}.kpi.b{background:#eff6ff;border-color:#bfdbfe;}.kpi.a{background:#fffbeb;border-color:#fde68a;}
.kl{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#64748b;margin-bottom:10px;}
.kv{font-size:22px;font-weight:800;color:#0f172a;}.kpi.g .kv{color:#15803d;}.kpi.b .kv{color:#1d4ed8;}.kpi.a .kv{color:#92400e;}
.ks{font-size:11px;color:#94a3b8;margin-top:4px;}
.section-title{font-size:14px;font-weight:800;color:#0f172a;text-transform:uppercase;letter-spacing:.8px;margin:28px 0 14px;padding-bottom:8px;border-bottom:2px solid #e2e8f0;}
.tbl-wrap{border:1.5px solid #e2e8f0;border-radius:14px;overflow:hidden;margin-bottom:28px;}
table{width:100%;border-collapse:collapse;}
thead tr{background:#1e293b;}thead th{padding:13px 14px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.7px;color:#f1f5f9;text-align:left;}
thead th.r{text-align:right;}thead th.c{text-align:center;}
tbody td{padding:13px 14px;border-bottom:1px solid #e2e8f0;vertical-align:middle;}
tfoot tr{background:#0f172a;}tfoot td{padding:14px;font-weight:700;color:#fff;font-size:14px;}
.gst-box{background:#fff7ed;border:1.5px solid #fed7aa;border-radius:12px;padding:20px 26px;margin-bottom:24px;}
.gst-box h4{font-size:11px;font-weight:700;color:#c2410c;text-transform:uppercase;letter-spacing:.8px;margin-bottom:14px;}
.gst-row-inner{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;}
.gc{background:#fff;border:1px solid #fed7aa;border-radius:10px;padding:14px 12px;text-align:center;}
.gc.hi{background:#fff7ed;border-color:#fb923c;}.gl{font-size:10px;font-weight:700;color:#9a3412;text-transform:uppercase;letter-spacing:.6px;}
.gv{font-size:18px;font-weight:700;color:#c2410c;margin-top:7px;}
.ftr{background:#f8fafc;border-top:1.5px solid #e2e8f0;padding:22px 50px;text-align:center;}
.ftr p{font-size:12px;color:#64748b;line-height:1.9;}
.btn-row{text-align:center;margin-top:30px;padding-bottom:40px;}
.bp{padding:13px 36px;background:#0f172a;color:#fff;border:none;border-radius:9px;font-size:14px;font-weight:700;cursor:pointer;margin-right:12px;}
.bs{padding:13px 26px;background:#f1f5f9;color:#1e293b;border:1.5px solid #cbd5e1;border-radius:9px;font-size:14px;cursor:pointer;}
@media print{body{background:#fff;padding:0;}.wrap{box-shadow:none;border-radius:0;}.btn-row{display:none;}}
</style></head><body><div class="wrap">
<div class="hdr">
<div><div class="co-name">${COMPANY_NAME}</div>
<div class="co-meta">${COMPANY_ADDRESS}<br>${COMPANY_PHONE} &nbsp;|&nbsp; ${COMPANY_EMAIL}<br>GSTIN: ${COMPANY_GST}</div></div>
<div><div class="rpt-title">Sales Report</div>
<div class="period">Period: ${periodLabel}</div>
<div class="gen">Generated: ${new Date().toLocaleDateString("en-IN",{day:"numeric",month:"long",year:"numeric"})}</div></div></div>
<div class="body">
<div class="kpi-grid">
<div class="kpi g"><div class="kl">Total Revenue</div><div class="kv">&#8377; ${totalRevenue.toLocaleString("en-IN")}</div><div class="ks">GST inclusive</div></div>
<div class="kpi b"><div class="kl">Total Orders</div><div class="kv">${orders.length}</div><div class="ks">${cartOrders} cart &bull; ${singleOrders} single</div></div>
<div class="kpi"><div class="kl">Total Items</div><div class="kv">${totalItems}</div><div class="ks">units sold</div></div>
<div class="kpi a"><div class="kl">Avg Order Value</div><div class="kv">&#8377; ${avgOrder.toLocaleString("en-IN")}</div><div class="ks">per order</div></div>
<div class="kpi"><div class="kl">GST Collected</div><div class="kv">&#8377; ${totalGST.toLocaleString("en-IN")}</div><div class="ks">18% total</div></div>
</div>

<div class="section-title">&#9642; Product-wise Sales Breakdown &mdash; ${periodLabel}</div>
<div class="tbl-wrap"><table>
<thead><tr>
<th class="c" style="width:40px;">#</th>
<th>Product Name</th>
<th class="c">Type</th>
<th class="c">Qty Sold</th>
<th class="r">Total Revenue</th>
</tr></thead>
<tbody>${prodRows}</tbody>
<tfoot><tr>
<td colspan="3" style="color:#94a3b8;">Total &mdash; ${prodBreakdown.length} product${prodBreakdown.length !== 1 ? "s" : ""}</td>
<td style="text-align:center;">${totalItems}</td>
<td style="text-align:right;font-size:16px;">&#8377; ${totalRevenue.toLocaleString("en-IN")}</td>
</tr></tfoot>
</table></div>

<div class="section-title">&#9642; Order Details &mdash; ${orders.length} Confirmed Orders</div>
<div class="tbl-wrap"><table>
<thead><tr>
<th class="c" style="width:40px;">#</th>
<th>Invoice / Order ID</th>
<th>Customer</th>
<th>Products</th>
<th class="c">Items</th>
<th class="r">Amount</th>
<th class="c">Type</th>
<th class="c">Date</th>
</tr></thead>
<tbody>${orderRows}</tbody>
<tfoot><tr>
<td colspan="4" style="color:#94a3b8;">Total &mdash; ${orders.length} orders &mdash; ${periodLabel}</td>
<td style="text-align:center;">${totalItems}</td>
<td style="text-align:right;font-size:16px;">&#8377; ${totalRevenue.toLocaleString("en-IN")}</td>
<td colspan="2"></td>
</tr></tfoot>
</table></div>

<div class="gst-box"><h4>&#9642; GST Summary &mdash; ${periodLabel}</h4>
<div class="gst-row-inner">
<div class="gc"><div class="gl">Gross Revenue (GST Incl.)</div><div class="gv">&#8377; ${totalRevenue.toLocaleString("en-IN")}</div></div>
<div class="gc"><div class="gl">Taxable Base (excl. GST)</div><div class="gv">&#8377; ${baseRevenue.toLocaleString("en-IN")}</div></div>
<div class="gc"><div class="gl">CGST 9%</div><div class="gv">&#8377; ${Math.round(totalGST/2).toLocaleString("en-IN")}</div></div>
<div class="gc hi"><div class="gl">Total GST 18%</div><div class="gv">&#8377; ${totalGST.toLocaleString("en-IN")}</div></div>
</div></div></div>
<div class="ftr"><p><strong>${COMPANY_NAME}</strong> &nbsp;|&nbsp; ${COMPANY_PHONE} &nbsp;|&nbsp; ${COMPANY_EMAIL}</p>
<p>GSTIN: ${COMPANY_GST} &nbsp;&bull;&nbsp; Computer-generated sales report.</p></div>
</div>
<div class="btn-row"><button class="bp" onclick="window.print()">&#128438; Download / Print PDF</button><button class="bs" onclick="window.close()">Close</button></div>
</body></html>`);
    win.document.close(); win.focus();
};

export const downloadDesignImage = (base64Image, orderId) => {
    const link = document.createElement("a");
    link.href = base64Image; link.download = `design-${orderId}.png`;
    document.body.appendChild(link); link.click(); document.body.removeChild(link);
};
